/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import CDSModalFooter from '@carbon/web-components/es/components/modal/modal-footer.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import './filter-panel-input-select';
import styles from './filter-panel.scss';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * extends the CDSModalFooter
 *
 * @element c4d-filter-modal-footer
 */
@customElement(`${c4dPrefix}-filter-modal-footer`)
class C4DFilterModalFooter extends StableSelectorMixin(CDSModalFooter) {
  static get stableSelector() {
    return `${c4dPrefix}-filter-modal-footer`;
  }

  static styles = styles; // `styles` here is a `CSSResult` generated by custom WebPack loader
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DFilterModalFooter;
